import React from "react";
import { useI18n } from "@/i18n";
import { CONTACT, LOGO_URL } from "@/constants";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";

export default function ContactFooter() {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer id="contact" data-testid="site-footer" className="relative bg-black border-t border-white/10 overflow-hidden">
      <div className="filament-bar h-1 w-full" />

      <section className="max-w-7xl mx-auto px-6 sm:px-8 py-20">
        <div className="font-mono-accent text-xs uppercase tracking-[0.25em] text-brand-blue-light">
          {t.contact.eyebrow}
        </div>
        <h2 className="font-heading mt-3 text-4xl sm:text-5xl font-black tracking-tighter">
          {t.contact.title}
        </h2>
        <p className="mt-4 text-zinc-400 max-w-2xl">{t.contact.subtitle}</p>

        <div className="mt-10 grid md:grid-cols-2 gap-4 max-w-3xl">
          <a
            data-testid="footer-email"
            href={`mailto:${CONTACT.email}`}
            className="group flex items-center justify-between p-6 border border-white/10 hover:border-brand-blue/50 bg-zinc-900/40 transition-colors"
          >
            <div className="flex items-center gap-4">
              <div className="h-10 w-10 rounded-sm bg-brand-blue/15 border border-brand-blue/40 flex items-center justify-center text-brand-blue-light">
                <Mail size={18} />
              </div>
              <div>
                <div className="font-mono-accent text-[10px] uppercase tracking-widest text-zinc-500">
                  {t.contact.email_label}
                </div>
                <div className="font-heading font-semibold mt-0.5">{CONTACT.email}</div>
              </div>
            </div>
            <ArrowUpRight size={16} className="text-zinc-500 group-hover:text-brand-blue-light transition-colors" />
          </a>
          <a
            data-testid="footer-phone"
            href={`tel:${CONTACT.phone.replace(/\./g, "")}`}
            className="group flex items-center justify-between p-6 border border-white/10 hover:border-brand-blue/50 bg-zinc-900/40 transition-colors"
          >
            <div className="flex items-center gap-4">
              <div className="h-10 w-10 rounded-sm bg-brand-blue/15 border border-brand-blue/40 flex items-center justify-center text-brand-blue-light">
                <Phone size={18} />
              </div>
              <div>
                <div className="font-mono-accent text-[10px] uppercase tracking-widest text-zinc-500">
                  {t.contact.phone_label}
                </div>
                <div className="font-heading font-semibold mt-0.5">{CONTACT.phone}</div>
              </div>
            </div>
            <ArrowUpRight size={16} className="text-zinc-500 group-hover:text-brand-blue-light transition-colors" />
          </a>
        </div>
      </section>

      <section className="border-t border-white/5 bg-[#060606]">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-12 flex flex-col items-center gap-6">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="AP3D" className="h-10 w-10 object-cover rounded-sm border border-white/10" />
            <div className="leading-none">
              <div className="font-heading font-extrabold text-lg">ALL POSSIBLE 3D SOLUTIONS</div>
              <div className="font-mono-accent text-[10px] text-zinc-500 tracking-widest mt-1">
                CUSTOM · CRAFTED · PRINTED
              </div>
            </div>
          </div>

          <blockquote
            data-testid="footer-quote"
            className="font-heading text-2xl sm:text-3xl font-black tracking-tight text-center max-w-3xl"
          >
            <span className="inline-block bg-gradient-to-r from-brand-blue-light via-white to-brand-cyan bg-clip-text text-transparent">
              "{t.footer.quote}"
            </span>
          </blockquote>

          <div className="font-mono-accent text-[11px] uppercase tracking-[0.25em] text-zinc-600">
            © {year} All Possible 3D Solutions · {t.footer.rights}
          </div>
        </div>
      </section>
    </footer>
  );
}
